import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { LgdTextAreaComponent } from "./lgdTextArea.component";
import { ForgeModule } from "@tylertech/forge-angular";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ForgeModule,
    ],
    declarations: [LgdTextAreaComponent],
    exports: [
        ReactiveFormsModule,
        LgdTextAreaComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdTextAreaModule { }
